import { apiRequest } from './client';

/**
 * PayPal/Zettle LIVE readiness (L-05): conexión OAuth del comercio con Zettle, desde el web del dueño.
 *
 * El navegador NUNCA ve un token: recibe la URL de autorización, navega a Zettle, y a la vuelta solo
 * reenvía `code` y `state` al backend con su sesión. El canje del code y el guardado cifrado de la
 * credencial ocurren en el servidor. Con la reconciliación apagada, todas responden 409
 * PAYMENT_RECONCILIATION_DISABLED.
 */

export interface ZettleConnectionAccount {
  id: string;
  externalAccountId: string;
  displayName: string;
  developerMode: boolean;
}

export interface ZettleCredentialSummary {
  status: 'ACTIVE' | 'REAUTH_REQUIRED' | 'REVOKED';
  scopes: string;
  tokenLastFour: string;
  accessTokenExpiresAt: string;
  lastRefreshedAt: string | null;
}

export interface ZettleConnection {
  connected: boolean;
  account: ZettleConnectionAccount | null;
  credential: ZettleCredentialSummary | null;
  /** Si la plataforma abrió LIVE para esta cuenta. Solo informativo: el servidor lo comprueba en cada cobro. */
  liveEnabled: boolean;
}

/** Texto que el dueño escribe para desconectar (el backend exige exactamente este). */
export const ZETTLE_DISCONNECT_CONFIRMATION = 'DESCONECTAR';

export const getZettleConnection = () =>
  apiRequest<ZettleConnection>('/api/payment-providers/zettle/connection');

export const beginZettleAuthorization = () =>
  apiRequest<{ authorizeUrl: string; expiresAt: string }>('/api/payment-providers/zettle/oauth/authorize', {
    method: 'POST',
    body: JSON.stringify({}),
  });

export const completeZettleAuthorization = (code: string, state: string) =>
  apiRequest<{ account: ZettleConnectionAccount; credential: ZettleCredentialSummary }>('/api/payment-providers/zettle/oauth/callback', {
    method: 'POST',
    body: JSON.stringify({ code, state }),
  });

export const disconnectZettle = (confirm: string) =>
  apiRequest<{ disconnected: true; providerDisconnected: boolean }>('/api/payment-providers/zettle/disconnect', {
    method: 'POST',
    body: JSON.stringify({ confirm }),
  });
